import React, { useState, Fragment, useEffect } from 'react';
import './style.scss';
import {
  Select, DatePicker, Table, Tag, notification, Upload, Radio, Checkbox,
} from 'antd';
import { Link, withRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import CMActions from '@Actions/settings/cmActions';
import H3Text from '@Uilib/h3Text';
import Helpers from '@Apis/helpers';
import ProductActions from '@Actions/productActions';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import STActions from '@Actions/stActions';
import TenantActions from '@Actions/tenantActions';
import DepartmentActions from '@Actions/departmentActions';
import InventoryLocationActions from '@Actions/settings/inventoryLocationActions';
import StockMasterActions from '@Actions/inventory/stockMasterActions';
import CustomFieldV2 from '@Components/Common/CustomFieldV2';
import SelectDepartment from '@Components/Common/SelectDepartment';
import Constants, { QUANTITY } from '@Apis/constants';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';
import PRZSelect from '../../../../Common/UI/PRZSelect';

const { Option } = Select;
const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Upload</div>
  </div>
);

const transferTypes = {
  1: 'SAME BUSINESS',
  2: 'OTHER BUSINESS',
};

function MultiStockAdjustmentForm({
  batches, adjustmentType, user, createIndentLoading, callback, getDocCFV2, customFieldsProps, tableType, createStLoading,
  sourceDepartmentName, getInventoryLocations, getTenantsLoading, tenants, getUsers, sourceTenantDepartmentId, getTenants, getInventoryLocationsLoading,
  adjustBatch, adjustBatchesLoading, inventoryLocations, users, sourceDepartmentId, createSt, getCM, customMessageStockAdjustment, cfV2DocStockTransfer, cfV2DocStockAdjustment,
}) {
  const inventoryLocationEnabled = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
  const [description, setDescription] = useState('');
  const [selectedAdjustmentReason, setSelectedAdjustmentReason] = useState('');
  const [selectedTransferType, setSelectedTransferType] = useState('SAME BUSINESS');
  const [transferTypeValue, setTransferTypeValue] = useState(1);
  const [destinationDepartment, setDestinationDepartment] = useState('');
  const [destinationDepartmentId, setDestinationDepartmentId] = useState('');
  const [destinationTenant, setDestinationTenant] = useState('');
  const [remark, setRemark] = useState('');
  const [checkedRecipients, setCheckedRecipients] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const [formSubmitted, setFormSubmitted] = useState('');
  const [data, setData] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [customFields, setCustomFields] = useState([]);
  const [toRecipients, setToRecipients] = useState([]);
  const [currentAction, setCurrentAction] = useState('');

  function convertBatchToRequiredData() {
    // here we check if there's an case of adjustment we create  object for table filling for adjustment else it creates for stock transfer
    const copyData = JSON.parse(JSON.stringify(batches));

    const convertedData = adjustmentType === 'OUTWARD' ? copyData.map((item) => ({
      ...item,
      adjustment_quantity: 0,
      onhand_quantity: 0,

    })) : copyData.map((item) => ({
      key: item.key,
      asset: [{ url: item.assets?.[0].url }],
      product_sku_name: item.product_sku_name,
      availableQuantity: item.available_qty,
      thresholdQuantity: item?.threshold_qty,
      quantity: item.available_qty,
      product_sku_id: item.product_sku_id,
      internal_sku_code: item.internal_sku_code,
      tenantProductId: item.tenant_product_id,
      sourceBatchId: item.batch_id,
      product_batches: [
        {
          batch_id: item.batch_id,
          batch_number: item.batch_number,
          tenant_product_id: item.tenant_product_id,
          available_qty: item.available_qty,
          expiry_date: item.expiry_date,
          created_by: 2,
          created_at: item.created_at,
          tenant_department_id: item.tenant_department_id,
          lot_number: item?.lot_number,
          custom_batch_number: item?.custom_batch_number,
          cost_price: item?.cost_price,
          selling_price: item?.selling_price,
          inventory_location_id: item.inventory_location_id,
          mrp: item.mrp === null ? 0 : item?.mrp,
          is_rejected_batch: item?.is_rejected_batch,
          org_id: item.org_id,
          tenant_id: item.tenant_id,
          is_archived: item.is_archived,
          product_sku_id: item.product_sku_id,
          inventory_location_path: item.inventory_location_path,
          inventory_location_name: item.inventory_location_name,
          consumed_qty: item.available_qty,
          batch_in_use: true,
        },
      ],
      expiry_days: -1,
      unit: item.uom_info.uom_name,
      uom_info: item.uom_info,
      product_sku_info: {
        product_sku_id: item.product_sku_id,
        product_sku_name: item.product_sku_name,
        colour: null,
        is_active: false,
        pan_india_gst: 18,
        remote_item_id_1: null,
        unit: item.uom_info.uom_name,
        quantity: null,
        modified_by: 2,
        uom_id: item.uom_info.uom_id,
        tax_id: 405,
        custom_fields: null,
        is_perishable: false,
        expiry_days: -1,
        purchase_uom_id: item.uom_info.uom_id,
        uom_list: item?.uom_info,
        purchase_uom_info: item.purchase_uom_info,
        uom_info: item?.uom_info,
        unicommerce_sku_code: null,
        org_id: item.org_id,
        internal_sku_code: item.internal_sku_code,
        product_batch_counter: 4,
        shopify_variant_id: null,
        shopify_parent_id: null,
        tally_product_name: null,
        shopify_shop_name: null,
        tally_updated_at: null,
        tally_product_guid: null,
        tally_stock_group_name: null,
        tally_unit_name: null,
        tally_purchase_account: null,
        is_marketplace_product: false,
        rejected_quantity: null,
        ratio: item.uom_info.ratio,
        uqc: item.uom_info.uqc,
      },
      sku: item.product_sku_id,
    }));

    setData(convertedData);
  }

  useEffect(() => {
    if (tableType === 'STOCK_TRANSFER') {
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: tableType,
      };
      getDocCFV2(payload);
    }

    getTenants(1, '', true, user?.tenant_info?.org_id, 100, () => { });
    getInventoryLocations(Number(Helpers.getTenantDepartmentId(user)), '', null, true);
    convertBatchToRequiredData();
  }, []);

  useEffect(() => {
    if (tableType === 'STOCK_TRANSFER' && cfV2DocStockTransfer?.data?.success && customFields.length === 0) {
      const newCustomFields = CustomFieldHelpers.getCfStructure(cfV2DocStockTransfer?.data?.document_custom_fields, true) || [];

      setCustomFields(newCustomFields);
    } else if (tableType === 'STOCK_ADJUSTMENT' && cfV2DocStockAdjustment?.data?.success && customFields.length === 0) {
      const newCustomFields = CustomFieldHelpers.getCfStructure(cfV2DocStockAdjustment?.data?.document_custom_fields, true) || [];

      setCustomFields(newCustomFields);
    }
  }, [cfV2DocStockTransfer?.data?.success, cfV2DocStockAdjustment?.data?.success]);

  function isDataValidST() {
    let dataValid = true;
    const isWarehouseLocationRequired = user?.tenant_info?.inventory_config?.settings?.is_inventory_location_mandatory;
    for (let i = 0; i < data.length; i++) {
      if (!Number(data[i].quantity) || !data[i].product_sku_name
        || Helpers.getValueTotalInObject(data[i]?.product_batches?.filter((item) => (item?.batch_in_use)), 'consumed_qty') !== Number(data[i]?.quantity)
        || Helpers.getValueTotalInObject(data[i]?.product_batches?.filter((item) => (item?.batch_in_use)), 'available_qty') < Number(data[i]?.quantity)
        || (transferTypeValue === 1 ? (isWarehouseLocationRequired && !data[i]?.inventory_location_id) : false)
      ) {
        dataValid = false;
      }
    }
    return dataValid;
  }

  function customInputChange(fieldValue, cfId) {
    const newCustomField = customFields.map((customField) => {
      if (customField?.cfId === cfId) {
        if (customField?.fieldType === 'ATTACHMENT') {
          return {
            ...customField,
            fieldValue: fieldValue?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
            })),

          };
        }
        return {
          ...customField,
          fieldValue,
        };
      }
      return {
        ...customField,
      };
    });
    setCustomFields(newCustomField);
  }

  function handleCreateSt(withApproval) {
    setFormSubmitted(true);
    const destinationDptId = tenants?.data?.filter((item) => item?.tenant_id === destinationTenant)?.[0]?.default_store_id;
    const getStBatches = (stbatches, sourceTenantProductId, destTenantProductId, inventoryLocationId) => {
      const updatedBatches = [];
      for (let i = 0; i < stbatches?.length; i++) {
        const newBatch = {
          ...stbatches[i],
          quantity: stbatches[i]?.consumed_qty,
          is_rejected_batch: !!stbatches[i]?.is_rejected_batch,
          source_tenant_product_id: sourceTenantProductId,
          destination_tenant_product_id: destTenantProductId,
          source_tenant_department_id: sourceTenantDepartmentId,
          destination_inventory_location_id: inventoryLocationId,
          destination_tenant_department_id: transferTypeValue === 1 ? destinationDepartmentId : destinationDptId,
        };
        delete newBatch.tenant_department_id;
        delete newBatch.tenant_product_id;
        updatedBatches.push(newBatch);
      }
      return updatedBatches;
    };
    if (isDataValidST() && selectedDate && (checkedRecipients ? toRecipients?.length : true) && sourceDepartmentId && (transferTypeValue === 1 ? destinationDepartment : destinationTenant) && !customFields?.filter((customField) => customField.isActive && customField.isRequired && (customField?.fieldType === 'ATTACHMENT' ? !customField?.fieldValue?.length : !customField?.fieldValue))?.length) {
      const stockTransferLines = [];
      for (let i = 0; i < data?.length; i++) {
        stockTransferLines.push({
          tenant_product_id: data[i]?.tenantProductId,
          quantity: data[i]?.quantity,
          uom_id: data[i]?.uom_info?.uom_id,
          uom_info: data[i]?.uom_info,
          source_product_batches: getStBatches(data[i]?.product_batches?.filter((item) => item?.consumed_qty > 0), data[i]?.tenantProductId, null, data[i]?.inventory_location_id),
        });
      }
      const payload = {
        source_tenant_department_id: sourceTenantDepartmentId,
        destination_tenant_department_id: transferTypeValue === 1 ? destinationDepartmentId : destinationDptId,
        stock_transfer_date: selectedDate,
        custom_fields: customFields?.length ? customFields?.map((customField) => ({
          cf_id: customField?.cfId,
          field_name: customField?.fieldName,
          field_value: customField?.fieldValue,
          field_type: customField?.fieldType,
          is_required: customField.isRequired,
          is_active: customField.isActive,
          default_data: customField?.defaultData,
          placeholder: customField?.placeholder,
        })) : [],
        remark,
        status: withApproval ? 'ISSUED' : 'DRAFT',
        stock_transfer_lines: stockTransferLines,
        attachments: fileList?.map((attachment) => ({
          url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
        })) || [],
        notification_recipients: checkedRecipients ? toRecipients : [],
      };
      createSt(payload, () => {
        setCurrentAction('');

        callback();
      }, withApproval);
    } else {
      setCurrentAction('');
      notification.open({
        type: 'error',
        message: 'Please provide all required inputs.',
        duration: 4,
        placement: 'top',
      });
    }
  }

  function handleDelete(key) {
    if (data.length === 1) {
      notification.open({
        message: 'You need to have atleast 1 data to proceed with Write off / Transfer.',
        duration: 4,
        type: 'error',
        placement: 'top',
      });
    } else {
      const copyData = data.filter((item) => item.key !== key);
      setData(copyData);
    }
  }
  const StockAdjustmentColumns = () => {
    const columns = [
      {
        title: 'SKU#',
        render: (record) => (
          <div>
            <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
              <div>
                #
                {record?.internal_sku_code}
              </div>
            </Link>
          </div>
        ),
        fixed: 'left',
      },
      {
        title: 'PRODUCT',
        width: '200px',
        render: (record) => (
          <div>
            <div style={{ maxWidth: '200px' }}>
              <div>{record?.product_sku_name}</div>
              <div className="qr__status" style={{ backgroundColor: record?.is_rejected_batch ? '#ee2232' : '#2fbc6e' }}>
                {record?.is_rejected_batch ? 'Bad' : 'Good'}
              </div>
            </div>
          </div>
        ),
      },
      {
        title: 'AVAILABLE STOCK',
        render: (record) => (
          <Fragment>
            <Fragment>
              <div>{`${QUANTITY(record?.available_qty, record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}</div>
            </Fragment>
          </Fragment>
        ),
      },
      {
        title: 'BATCH INFO',
        render: (record) => (
          <div>
            <div>
              {(record?.custom_batch_number || record?.batch_number) && (
                <div>
                  <span style={{ fontWeight: '600' }}>Batch</span>
                  &nbsp;
                  <span>
                    #
                    {record?.custom_batch_number ? record?.custom_batch_number : record?.batch_number}
                  </span>

                </div>
              )}
              {record?.lot_number && (
                <div>
                  <span style={{ fontWeight: '600' }}>Lot</span>
                  &nbsp;
                  <span>
                    #
                    {record?.lot_number && (record?.lot_number)}
                  </span>

                </div>
              )}
            </div>
          </div>

        ),
      },
      {
        title: 'EXPIRY',
        render: (record) => {
          const expiryMoment = dayjs(dayjs(record.expiry_date).format('YYYY-MM-DD'));
          let shelfLife = 0;
          if (dayjs().isSameOrBefore(expiryMoment)) {
            shelfLife = expiryMoment.diff(dayjs(dayjs().format('YYYY-MM-DD')), 'days');
          }
          // eslint-disable-next-line prefer-const
          let shelfLifePct = Math.round(((shelfLife / record.expiry_days) * 100));

          return (
            <div>
              {
                shelfLife !== 0 ? (
                  <div>
                    <div>
                      {record?.expiry_date === '2099-01-01'
                        ? <Tag color="green">No expiry</Tag> : (
                          <div className="product-batch-shelf-life">
                            <div
                              className="progress-line__wrapper"
                              style={{
                                width: '80px',
                                backgroundColor: shelfLifePct < 25 ? 'rgba(216,51,15,0.2)' : shelfLifePct > 75 ? 'rgba(23,181,77,0.2)' : 'rgba(204,185,10,0.2)',
                              }}
                            >
                              <div
                                className="progress-line"
                                style={{
                                  width: `${shelfLifePct > 100 ? 100 : shelfLifePct}%`,
                                  backgroundColor: shelfLifePct < 25 ? '#D8330F' : shelfLifePct > 75 ? '#17B54D' : '#CCB90A',
                                }}
                              />
                            </div>
                            <span>
                              {`${shelfLife} Days (${shelfLifePct > 100 ? 100 : shelfLifePct}%)`}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                ) : (
                  <div className="inventory-lookup__expired-row">
                    Expired on&nbsp;
                    {dayjs(record?.expiry_date).format('DD/MMM/YYYY')}
                  </div>
                )
              }
            </div>
          );
        },
      },
      {
        title: 'NEW ON HAND QTY',

        render: (record) => (

          <div>
            <input
              value={record.onhand_quantity}
              type="Number"
              disabled={!record || adjustBatchesLoading}
              onWheel={(event) => event.target.blur()}
              onChange={(event) => {
                const copyData = JSON.parse(JSON.stringify(data));
                const updatedData = copyData.map((obj) => {
                  if (obj.key === record.key) {
                    return { ...obj, onhand_quantity: event.target.value };
                  }
                  return obj;
                });
                setData(updatedData);
              }}
              className="orgFormInput"
            />
          </div>
        ),
      },
      {
        title: 'QUANTITY ADJUSTED',
        width: '150px',
        render: (item) => (
          <Fragment>
            <H3Text text={`${QUANTITY(Number(item?.onhand_quantity - item?.available_qty))} ${item?.uom_info?.uqc?.toProperCase()}`} />
          </Fragment>
        ),
      },

      {
        title: '',
        render: (record) => (
          data.length !== record.key && (
            <div className="create-multi-adjustment__delete-line-button" onClick={() => { handleDelete(record.key); }}>
              <CloseOutlined />
            </div>
          )
        ),
        responsive: ['xs', 'sm', 'md', 'lg', 'xxl'],
        width: '40px',
        fixed: 'right',
      },

    ];
    return columns;
  };
  const StockTransferColumns = () => {
    const columns = [
      {
        title: 'SKU#',
        width: '100px',
        render: (record) => (
          <div>
            {record?.internal_sku_code
              ? (
                <Link to={`/inventory/product/view/${record?.product_sku_id}`} target="_blank">
                  <div>
                    #
                    {record?.internal_sku_code}
                  </div>
                </Link>
              ) : '-'}
          </div>
        ),
        fixed: 'left',
      },
      {
        title: 'PRODUCT',
        width: '260px',
        render: (text, record) => (
          <div>
            {record?.product_sku_name ? (
              <div style={{ width: '200px' }}>
                <div>
                  {record?.product_sku_name}
                </div>
                <div className="qr__status" style={{ backgroundColor: record?.product_batches?.[0]?.is_rejected_batch ? '#ee2232' : '#2fbc6e' }}>
                  {record?.product_batches?.[0]?.is_rejected_batch ? 'Bad' : 'Good'}
                </div>

              </div>
            ) : '-'}
          </div>
        ),
      },
      {
        title: 'AVAILABLE QTY',
        width: '150px',
        render: (text, record) => (
          <Fragment>
            {`${QUANTITY(Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => (item?.batch_in_use)), 'available_qty'), record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase() || ''}`}
            {(Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => item?.batch_in_use), 'available_qty') && record?.uom_info) ? (
              <H3Text
                text={`In ${record?.product_batches?.filter((item) => item?.batch_in_use)?.length || '0'} Batches`}
                className="table-subscript"
              />
            ) : ''}
          </Fragment>
        ),
      },
      {
        title: 'BATCH INFO',
        render: (record) => (
          <div>
            {record?.product_batches?.[0]
              ? (
                <div>
                  {(record?.product_batches?.[0]?.custom_batch_number || record?.product_batches?.[0].batch_number) && (
                    <div>
                      <span style={{ fontWeight: '600' }}>Batch</span>
                      &nbsp;
                      <span>
                        #
                        {record?.product_batches?.[0]?.custom_batch_number ? record?.product_batches?.[0]?.custom_batch_number : record?.product_batches?.[0].batch_number}
                      </span>

                    </div>
                  )}
                  {record?.product_batches?.[0]?.lot_number && (
                    <div>
                      <span style={{ fontWeight: '600' }}>Lot </span>
                      &nbsp;
                      <span>
                        #
                        {record?.product_batches?.[0]?.lot_number && (record?.product_batches?.[0]?.lot_number)}
                      </span>

                    </div>
                  )}
                </div>
              ) : '-'}
          </div>

        ),
      },
      {
        title: 'TRANSFER QTY',
        width: '150px',
        render: (text, record) => {
          const hasError = () => (record?.tenantProductId && (Number(record?.availableQuantity) < Number(record?.quantity)));
          return (
            <div>
              <div className="st-adjustment-qty-input">
                <input
                  value={record.quantity}
                  type="Number"
                  disabled={!record?.tenantProductId}
                  onWheel={(event) => event.target.blur()}
                  onChange={(event) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    const batchesData = record?.product_batches;
                    let remainingQty = Number(event.target.value);
                    for (let i = 0; i < batchesData?.length; i++) {
                      batchesData[i].consumed_qty = 0;
                    }
                    for (let i = 0; i < batchesData?.length; i++) {
                      if (batchesData[i]?.batch_in_use) {
                        if (remainingQty > 0 && Number(batchesData[i].consumed_qty || '0') < batchesData?.[i]?.available_qty) {
                          batchesData[i].consumed_qty = batchesData?.[i]?.available_qty > remainingQty ? remainingQty : batchesData?.[i]?.available_qty;
                          remainingQty -= batchesData[i].consumed_qty;
                        } else {
                          batchesData[i].consumed_qty = 0;
                          remainingQty -= batchesData[i].consumed_qty;
                        }
                      }
                    }
                    const updatedData = copyData.map((obj) => {
                      if (obj.key === record.key) {
                        return { ...obj, quantity: event.target.value, product_batches: batchesData };
                      }
                      return obj;
                    });
                    setData(updatedData);
                  }}
                  className="orgFormInput"
                />
                <div className="st-adjustment-qty-input-uom">{record?.uom_info?.uqc?.toProperCase()}</div>
              </div>
              {
                hasError()
                && (
                  <div className="input-error">
                    *Entered quantity is more than available quantity
                  </div>
                )
              }
            </div>
          );
        },
      },
      {
        title: 'NEW ON HAND QTY',
        width: '150px',
        render: (item) => (
          <Fragment>
            {item?.quantity && item?.uom_info?.uqc ? (
              <H3Text text={`${QUANTITY(Number(item?.availableQuantity) - Number(item?.quantity))} ${item?.uom_info?.uqc?.toProperCase()}`} />
            ) : 0}
          </Fragment>
        ),
      },
      {
        title: 'LOCATION',
        width: '210px',
        render: (item) => {
          const isWarehouseLocationRequired = user?.tenant_info?.inventory_config?.settings?.is_inventory_location_mandatory;
          return (
            <Fragment>
              {
                selectedTransferType === 'SAME BUSINESS' ? (
                  <Fragment>
                    <PRZSelect
                      value={item.inventory_location_id}
                      loading={getInventoryLocationsLoading}
                      filterOption={false}
                      showSearch
                      disabled={!destinationDepartmentId}
                      onChange={(value) => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        const updatedData = copyData.map((record) => {
                          if (record.key === item.key) {
                            return {
                              ...record,
                              inventory_location_id: value,
                            };
                          }
                          return {
                            ...record,
                          };
                        });
                        setData(updatedData);
                      }}
                      onSearch={(keyword) => {
                        getInventoryLocations(destinationDepartmentId, keyword, null, true);
                      }}
                      style={{
                        width: '200px',
                      }}
                      showError={formSubmitted && isWarehouseLocationRequired && !item?.inventory_location_id}
                      errorName="*Please enter location"
                      errorClassName="input-error"
                      placeholder=""
                    >
                      {
                        inventoryLocations?.inventory_location?.filter((location) => location?.is_active)?.map((location) => (
                          <Option
                            key={location?.inventory_location_id}
                            value={location?.inventory_location_id}
                          >
                            <H3Text text={location?.inventory_location_path} className="create-new-batch__location-item" />
                          </Option>
                        ))
                      }
                    </PRZSelect>
                  </Fragment>
                ) : '-'
              }
            </Fragment>
          );
        },
      },
      {
        title: '',
        render: (text, record) => (
          data.length !== record.key && (
            <div className="create-multi-adjustment__delete-line-button" onClick={() => { handleDelete(record.key); }}>
              <CloseOutlined />
            </div>
          )
        ),
        fixed: 'right',
        width: '40px',
      },

    ];
    return columns;
  };

  return (
    <div className="" style={{ marginBottom: '40px' }}>
      <div className="create-multi-adjustment__header">
        <div className="ant-row">
          {adjustmentType === 'OUTWARD' && (
            <div className="ant-col-md-12 ant-col-xs-24" />
          )}
          {
            tableType === 'STOCK_TRANSFER' && (
              <div className="ant-col-md-12 ant-col-xs-24">
                <div className="create-multi-adjustment__header-row ">

                  <div className="create-multi-adjustment__input-row__label">
                    Transfer Type
                    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
                  </div>

                  <Radio.Group
                    disabled={createStLoading}
                    onChange={(event) => {
                      setDestinationDepartment(null);
                      setDestinationDepartmentId(null);
                      setCheckedRecipients(event.target.value === 2);
                      setSelectedTransferType(transferTypes[event.target.value]);
                      setTransferTypeValue(event.target.value);
                    }}
                    value={transferTypeValue}
                    style={{
                      width: 'calc(100% - 180px)',
                    }}
                  >
                    <Radio value={1}>Same Business Unit</Radio>
                    <Radio value={2}>Other Business Unit</Radio>
                  </Radio.Group>
                </div>
                <div className="create-multi-adjustment__header-row">
                  <div className="create-multi-adjustment__input-row__label">
                    Source Department
                  </div>
                  <div className="create-multi-adjustment__input-row__input" style={{ marginTop: '7px', fontWeight: '600' }}>
                    {sourceDepartmentName}
                  </div>
                </div>
                {transferTypeValue !== 1 && (
                  <div>
                    <div className="create-multi-adjustment__header-row">
                      <div className="create-multi-adjustment__input-row__label">
                        Destination Business Unit
                        <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
                      </div>
                      <PRZSelect
                        value={destinationTenant}
                        loading={getTenantsLoading}
                        showSearch
                        optionFilterProp="children"
                        onChange={(value) => {
                          setDestinationTenant(value);
                          setDestinationDepartmentId(tenants?.data?.filter((item) => item?.tenant_id === value)?.[0]?.default_store_id);
                          getInventoryLocations(tenants?.data?.filter((item) => item?.tenant_id === value)?.[0]?.default_store_id, '', null, true);
                          getUsers(value, null, `${Helpers.permissionEntities.STOCK_TRANSFER}.${Helpers.permissionTypes.READ},${Helpers.permissionEntities.GOOD_RECEIVING}.${Helpers.permissionTypes.CREATE}`, (usersCallbackData) => {
                            setToRecipients([...new Map(usersCallbackData?.data?.[0]?.tenant_user?.map((item) => [item.email, item])).values()]?.map((item) => item?.email));
                          });
                        }}
                        disabled={createStLoading}
                        className="create-multi-adjustment__input-row__input"
                        dropdownAlign={{ offset: [-4, 4] }}
                        style={{
                          background: 'white',
                          width: 'calc(100% - 180px)',
                          marginBottom: formSubmitted && !destinationTenant ? '0px' : '1.5px',
                        }}
                        placeholder="Select business unit.."
                        showError={formSubmitted && !destinationTenant}
                        errorName="*Please select a destination business unit"
                        errorClassName="input-error"
                      >
                        {tenants?.data?.filter((item) => item?.tenant_id !== user?.tenant_info?.tenant_id)?.map((tenant) => (
                          <Option key={tenant?.tenant_id} value={tenant?.tenant_id}>
                            {tenant?.tenant_name}
                          </Option>
                        ))}
                      </PRZSelect>
                    </div>
                  </div>

                )}
                {transferTypeValue !== 2 && (
                  <div>
                    <SelectDepartment
                      title="Destination Department"
                      selectedDepartment={destinationDepartment}
                      onChange={(value) => {
                        getInventoryLocations(value?.tenant_department_id, '', null, true);
                        setDestinationDepartment(value?.department_id);
                        setDestinationDepartmentId(value?.tenant_department_id);
                      }}
                      loading={getTenantsLoading}
                      disabled={createStLoading}
                      customStyle={{
                        width: '334px',
                        marginBottom: formSubmitted && !destinationTenant ? '0px' : '1.5px',
                      }}
                      labelClassName="create-multi-adjustment__input-row__label"
                      inputClassName="create-multi-adjustment__input-row__input"
                      containerClassName="create-multi-adjustment__header-row create-multi-adjustment__input-row"
                      emptyNotAllowed
                      excludedDepartments={sourceDepartmentId ? [sourceDepartmentId] : []}
                    />
                    <div>
                      {formSubmitted && !destinationDepartment && <div className="input-error" style={{ marginBottom: formSubmitted && !sourceTenantDepartmentId ? '10px' : '0px', marginLeft: '215px', marginTop: '0px' }}>*Please select a destination department</div>}
                    </div>
                  </div>
                )}

                <div className="create-multi-adjustment__header-row">
                  <div className="create-multi-adjustment__input-row__label">
                    Date
                    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
                  </div>
                  <div className="create-multi-adjustment__input-row__input">
                    <DatePicker
                      value={selectedDate}
                      onChange={(value) => {
                        setSelectedDate(value);
                      }}
                      disabled={createIndentLoading || createStLoading}
                      style={{
                        height: '28px',
                        border: '1px solid rgba(68, 130, 218, 0.2)'
                      }}
                    />
                    {formSubmitted && !selectedDate && <div className="input-error">Please select valid adjustment date*</div>}
                  </div>
                </div>
                {transferTypeValue !== 1 && (
                  <div>

                    <div style={{ marginTop: '10px', marginBottom: '10px' }} className="create-multi-adjustment__header-row">
                      <div className="create-multi-adjustment__input-row__label">
                        Recipients
                      </div>
                      <div style={{ width: 'calc(100% - 180px)' }}>
                        <div>
                          <Checkbox
                            disabled={createStLoading}
                            checked={checkedRecipients}
                            onChange={(event) => {
                              setCheckedRecipients(event.target.checked);
                            }}
                          />
                          <span style={{ fontWeight: '500', fontSize: '12px', marginLeft: '5px' }}>Send Email Notification to Recipients</span>
                        </div>
                        {checkedRecipients && (
                          <div className="create-multi-adjustment__header-row" style={{ marginTop: '2px' }}>
                            <PRZSelect
                              mode="tags"
                              value={toRecipients}
                              filterOption={false}
                              onChange={(value) => {
                                const recipients = [];
                                for (let i = 0; i < value?.length; i++) {
                                  if (Helpers.validateEmail(value[i])) {
                                    recipients.push(value[i]);
                                  }
                                }
                                setToRecipients(recipients);
                              }}
                              disabled={createStLoading || !destinationTenant}
                              maxTagCount="responsive"
                              style={{
                                paddingTop: '2px',
                                height: 'auto !important',
                              }}
                            >
                              {users && users?.data?.[0] && users?.data?.[0]?.tenant_user?.filter((item) => item.is_active)
                                .map((item) => (
                                  <Option key={item.user_id} value={item.email}>
                                    {item?.email}
                                  </Option>
                                ))}
                            </PRZSelect>
                          </div>
                        )}
                        <div style={{ marginTop: '2px', marginLeft: '30px' }}>{formSubmitted && checkedRecipients && !toRecipients?.length && <div className="input-error">*Please enter at least one recipient</div>}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )
          }
          {tableType === 'STOCK_TRANSFER' && (
            <CustomFieldV2
              customFields={customFields || []}
              formSubmitted={formSubmitted}
              customInputChange={(value, cfId) => customInputChange(value, cfId)}
              disableCase={createIndentLoading || createStLoading}
              isHorizontalUi
              hideTitle
            />
          )}
        </div>

        <div className="generic-table-container">
          <Table
            title={() => (
              <div>
                {adjustmentType === 'OUTWARD' && <H3Text text={`Adjustment Products (${batches?.length})`} className="create-multi-adjustment__table-label" />}
                {tableType === 'STOCK_TRANSFER' && <H3Text text={`Stock Transfer Products (${data.filter((item) => item.product_sku_name?.length > 0)?.length})`} className="create-multi-adjustment__table-label" />}
              </div>

            )}
            bordered
            showHeader
            size="small"
            loading={adjustBatchesLoading || createStLoading}
            columns={(adjustmentType === 'OUTWARD' && StockAdjustmentColumns()) || (tableType === 'STOCK_TRANSFER' && StockTransferColumns())}
            dataSource={data || []}
            currentPage
            scroll={{ x: 'max-content' }}
            pagination={false}
          />
        </div>
        {tableType === 'STOCK_TRANSFER' && (
          <div className="text-area__container" style={{ marginTop: '30px' }}>
            <label className="orgFormLabel" style={{ marginTop: '10px', marginBottom: '5px' }}>
              Additional Remarks
            </label>
            <textarea
              className="orgFormInput text-area"
              rows="4"
              cols="50"
              value={remark}
              onChange={(e) => {
                setRemark(e.target.value);
              }}
              disabled={createStLoading}
            />
          </div>
        )}
        {tableType === 'STOCK_TRANSFER' && (
          <div className="text-area__po-container" style={{ marginTop: '30px' }}>
            <label className="orgFormLabel" style={{ marginTop: '10px', marginBottom: '5px' }}>
              Attachment(s)
            </label>
            <Upload
              action={Constants.UPLOAD_FILE}
              listType="picture-card"
              fileList={fileList}
              disabled={createIndentLoading || createStLoading}
              onChange={(fileListData) => {
                setFileList(fileListData?.fileList?.map((item) => ({
                  ...item,
                  url: item?.response?.response?.location || item?.url,
                })));
              }}
              multiple
            >
              {fileList?.length >= 20 ? null : uploadButton}
            </Upload>
          </div>
        )}
      </div>
      <div className="create-multi-adjustment__footer">
        {adjustmentType === 'OUTWARD' && Helpers.getPermission(Helpers.permissionEntities.INVENTORY_INDENT,
          Helpers.permissionTypes.CREATE, user) && (
            <H3Button
              text="Save Adjustment"
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              customClass="create-multi-adjustment__footer-submit"
              onClick={() => {
                if (!adjustBatchesLoading) {
                  const copyData = JSON.parse(JSON.stringify(data));
                  const payload = copyData.map((item) => ({
                    batch_id: item?.batch_id,
                    quantity: item?.onhand_quantity - item?.available_qty,
                    uom_id: item?.uom_info?.uom_id,
                  }));
                  adjustBatch(payload, () => { callback(); });
                }
              }}
              disabled={adjustBatchesLoading}
              isLoading={adjustBatchesLoading}
            />
          )}
        {tableType === 'STOCK_TRANSFER' && Helpers.getPermission(Helpers.permissionEntities.INVENTORY_INDENT,
          Helpers.permissionTypes.CREATE, user) && (
            <H3Button
              text="Save Transfer"
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              customClass="create-multi-adjustment__footer-submit"
              onClick={() => {
                setCurrentAction('SAVE_AND_ISSUED');
                if (!createStLoading) {
                  handleCreateSt(true);
                }
              }}
              isLoading={currentAction === 'SAVE_AND_ISSUED' && (createStLoading)}
              disabled={createStLoading}
            />
          )}
      </div>
    </div>
  );
}

const mapStateToProps = ({
  ProductReducers, CFV2Reducers, TenantReducers, InventoryLocationReducers, STReducers, CMReducers, StockMasterReducers,
}) => ({
  createIndentLoading: ProductReducers.createIndentLoading,
  createStLoading: STReducers.createStLoading,
  tenants: TenantReducers.tenants,
  // customFieldsProps: CFV2Reducers.cfV2DocStockTransfer,
  users: TenantReducers.users,
  getInventoryLocationsLoading: InventoryLocationReducers.getInventoryLocationsLoading,
  inventoryLocations: InventoryLocationReducers.inventoryLocations,
  customMessageStockAdjustment: CMReducers.customMessageStockAdjustment,
  adjustBatchesLoading: StockMasterReducers.adjustBatchesLoading,
  cfV2DocStockTransfer: CFV2Reducers.cfV2DocStockTransfer,
  cfV2DocStockAdjustment: CFV2Reducers.cfV2DocStockAdjustment,
});

const mapDispatchToProps = (dispatch) => ({
  createIndent: (payload, callback, withApproval) => dispatch(ProductActions.createIndent(payload, callback, withApproval)),
  adjustBatch: (payload, callback) => dispatch(StockMasterActions.adjustBatches(payload, callback)),
  createSt: (payload, callback, withApproval) => dispatch(STActions.createSt(payload, callback, withApproval)),
  getTenants: (page, keyword, isVerified, orgId, limit, callback, tenantId) => dispatch(TenantActions.getTenants(page, keyword, isVerified, orgId, limit, callback, tenantId)),
  getInventoryLocations: (tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId) => dispatch(InventoryLocationActions.getInventoryLocations(tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable, tenantId)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (customFields) => dispatch(CFV2Actions.getDocCFV2Success(customFields)),
  getUsers: (tenantId, roleId, permissionType, callback) => dispatch(TenantActions.getUsers(tenantId, roleId, permissionType, callback)),
  getDepartments: (keyword, tenantId, page, limit, departmentId, callback) => dispatch(DepartmentActions.getDepartments(keyword, tenantId, page, limit, departmentId, callback)),
  getCM: (orgId, entityId, entityType, page, limit) => dispatch(CMActions.getCM(orgId, entityId, entityType, page, limit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MultiStockAdjustmentForm));
